import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NumberOfBedrooms from './number-of-bedrooms';
import NumberOfBedroomsDetail from './number-of-bedrooms-detail';
import NumberOfBedroomsUpdate from './number-of-bedrooms-update';
import NumberOfBedroomsDeleteDialog from './number-of-bedrooms-delete-dialog';

const NumberOfBedroomsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NumberOfBedrooms />} />
    <Route path="new" element={<NumberOfBedroomsUpdate />} />
    <Route path=":id">
      <Route index element={<NumberOfBedroomsDetail />} />
      <Route path="edit" element={<NumberOfBedroomsUpdate />} />
      <Route path="delete" element={<NumberOfBedroomsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NumberOfBedroomsRoutes;
